export default __webpack_public_path__ + "f3fe105ead88363ecdec4864a381fd08.svg";